/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { en, ko } from 'vuetify/locale'
import { VFileUpload } from 'vuetify/labs/VFileUpload'
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
ko.confirmEdit.ok='확인'
ko.confirmEdit.cancel='취소'
const vuetify=createVuetify({
  theme: {
    defaultTheme: 'light',
  },components: {
    VDateInput,VFileUpload
  },locale:{messages:{kr:ko,us:en}}
})
export default vuetify
